export default __webpack_public_path__ + "locales/el-GR/Payments.json?hash=012640fa89cf3474eba423f4c85d039e";